import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { Outlet, useMatches } from 'react-router'

const PageTitleContext = createContext({ pageTitle: 'ExpanDrive', setPageTitleOverride: () => {} })

export const pageTitleFromMatches = matches => {
  const routeTitle = [...matches].reverse().find(match => match.handle?.title)?.handle.title

  return routeTitle ? `${routeTitle} — ExpanDrive` : 'ExpanDrive'
}

const formatPageTitle = title => title?.endsWith(' — ExpanDrive') ? title : `${title} — ExpanDrive`

export const usePageTitle = titleOverride => {
  const { pageTitle, setPageTitleOverride } = useContext(PageTitleContext)

  useEffect(() => {
    if (!titleOverride) return undefined

    const nextTitle = formatPageTitle(titleOverride)
    setPageTitleOverride(nextTitle)
    document.title = nextTitle

    return () => setPageTitleOverride(null)
  }, [setPageTitleOverride, titleOverride])

  return pageTitle
}

export const DocumentTitle = () => {
  const routePageTitle = pageTitleFromMatches(useMatches())
  const [pageTitleOverride, setPageTitleOverride] = useState(null)
  const pageTitle = pageTitleOverride || routePageTitle
  const contextValue = useMemo(() => ({ pageTitle, setPageTitleOverride }), [pageTitle])

  useEffect(() => {
    document.title = pageTitle
  }, [pageTitle])

  return (
    <PageTitleContext.Provider value={contextValue}>
      <span aria-atomic="true" aria-live="polite" className="tw:sr-only">{pageTitle}</span>
      <Outlet />
    </PageTitleContext.Provider>
  )
}
